import { IClasses } from "../../../../../../../../models/classes";
import { getUserTimezone } from "../../../../../../../../utils/dateUtils";
import { TaskInfo } from "../../TaskWrap";
import moment from "moment-timezone";

export const getSelectetdClass = (classes: IClasses, userSelection: any[]) => {
    const selectedRecord = userSelection?.find(
        (record) =>
            record.Selected_Option__c === classes.HN_Session_title__c ||
            record.Second_Option__c === classes.HN_Session_title__c
    );

    return selectedRecord;
};

export const isOption = (title: string, userSelectionRecord: any[], optionKey: 'Selected_Option__c' | 'Second_Option__c') =>
    userSelectionRecord?.find(
        (record) =>
            record[optionKey] === title
    );

export const getTaskInfo = (classes: IClasses, language: string, taskType: string) => {
    let taskInfo: TaskInfo[] = [
        { name: "time", value: `${classes.Class_Start_Time__c} - ${classes.Class_End_Time__c}`, order: 0 },
    ];

    if (taskType === "Class Opt-in") {
        taskInfo.unshift({ name: "startDate", value: formatDay(classes.Class_Start_Date__c, language), order: 0 });
        taskInfo = taskInfo.concat(
            classes.Faculty.map((faculty, index) => ({
                name: `faculty_${index + 1}`,
                value: faculty.Name__r.Name,
                order: 2 + index,
            }))
        );
        taskInfo.push({ name: "remainingCapacity", value: classes.Participants_Cap_Remaining__c, order: classes.Faculty.length + 2 });
    } else {
        if (classes.HN_Session_Type__c) {
            taskInfo.push({ name: "sessionType", value: classes.HN_Session_Type__c, order: 1 });
        }
        if (classes.HN_Difficulty_Level__c) {
            taskInfo.push({ name: "difficultyLevel", value: classes.HN_Difficulty_Level__c, order: 2 });
        }
        if (classes.HN_Lunch_and_Snacks__c) {
            taskInfo.push({ name: "snacks", value: "Lunch & Snacks", order: 3 });
        }
    }
    return taskInfo;
};

const formatDay = (date: string, language: string) => {
    const locale =
        language === "Hebrew" ? "he-IL" : language === "Arabic" ? "ar-EG" : "en-us";

    // Parse the date in user's local timezone for consistent display across timezones
    const momentDate = moment.tz(date, getUserTimezone());
    return momentDate.locale(locale.toLowerCase()).format("dddd, MMM D, YYYY");
};